import { styled } from '@mui/material/styles';
import { Checkbox, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const CheckboxContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  minHeight: '40px',
});

export const StyledCheckbox = styled(Checkbox)(({ theme, error }) => ({
  padding: 0,
  marginRight: '8px',
  
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
    color: error 
      ? theme.palette.error.main
      : theme.palette.text.secondary,
    transition: theme.transitions.create(['color', 'transform'], {
      duration: theme.transitions.duration.shortest,
    }),
  },

  '&:hover': {
    backgroundColor: 'transparent',
    '& .MuiSvgIcon-root': {
      color: error 
        ? theme.palette.error.main 
        : theme.palette.primary.main,
    },
  },

  '&.Mui-checked': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.main,
      transform: 'scale(1.1)',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      '& .MuiSvgIcon-root': {
        color: theme.palette.primary.dark,
      },
    },
  },

  '&.Mui-disabled': {
    '& .MuiSvgIcon-root': {
      color: theme.palette.action.disabled,
    },
  },

  '&.Mui-focusVisible .MuiSvgIcon-root': {
    outline: `2px solid ${theme.palette.primary.main}`,
    outlineOffset: 2,
  },
}));

export const Label = styled(Typography)(({ theme, disabled }) => ({
  fontSize: '13px',
  lineHeight: '1.5',
  color: disabled ? theme.palette.text.disabled : theme.palette.text.primary,
  userSelect: 'none',
  cursor: disabled ? 'not-allowed' : 'pointer',
  display: 'flex',
  alignItems: 'center',

  '& .required': {
    color: theme.palette.error.main,
    marginLeft: '2px',
  },
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: '12px',
  marginTop: '4px',
  lineHeight: 1.2,
})); 